import React, { FC, useEffect } from 'react';
import { ReactComponent as HelpCenterIcon } from 'images/new-icons/help-center.svg';
import { ReactComponent as PrivacyPolicyIcon } from 'images/new-icons/privacy-policy.svg';
import { ReactComponent as TermsConditionsIcon } from 'images/new-icons/terms-conditions.svg';
import styles from './ProfileMenu.module.scss';
import useIsAuth from 'sdk/hooks/useIsAuth';
import { useGetMyUser } from 'sdk/hooks/user/useGetMyUser';
import { useTranslation } from 'react-i18next';
import ForwardArrow from '../UI/ForwardArrow';
declare global {
  interface Window {
    Intercom: any;
  }
}

type Props = {
  setProfileMenu: any
}

const menuItems = [
  {
    icon: <HelpCenterIcon />,
    title: 'Help Center',
  },
  {
    icon: <PrivacyPolicyIcon />,
    title: 'Privacy & Policy',
  },
  {
    icon: <TermsConditionsIcon />,
    title: 'Terms & Conditions',
  },
];

const ProfileMenuHelpItemss: FC<Props> = ({ setProfileMenu }) => {
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: user } = useGetMyUser(userId ?? '')
const {t }=  useTranslation() as any 
  useEffect(() => {
    if (!window.Intercom) {
      const script = document.createElement("script");
      script.src = "https://widget.intercom.io/widget/cez7qw6h";
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        initIntercom();
      };
    } else {
      initIntercom();
    }

    return () => {
      window.Intercom?.("shutdown");
    };
  }, [user]);

  const initIntercom = () => {
    if (user) {
      window.Intercom("boot", {
        app_id: "lraxwnph",
        user_id: user.id,
        name: user.username,
        email: user.email,
        created_at: Math.floor(new Date(user.created_at).getTime() / 1000),
        hide_default_launcher: true,
      });

      setTimeout(() => {
        window.Intercom("update", {
          email: user.email,
          user_id: user.id,
          name: user.aud
        });
      }, 3000);
    }
  };

  return (
    <div style={{ padding: '0px 8px' }}>
      {menuItems.map((item, index) => (
        <div key={index} className={styles.profile_menu_items} onClick={() => {
          if (item.title === 'Help Center') {
            window.Intercom("show")
          } else {
            setProfileMenu(item.title)
          }
        }}>
          {item.icon}
          <div className={styles.profile_menu_items__title} style={{ color: '#00000080' }}>{t(item.title)}</div>
          <div className={styles.profile_menu_items__arrow}>
            <ForwardArrow style={{ color: '#00000080' }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProfileMenuHelpItemss;
